import { activationError }           from './activationError';
import { activationLinkAlreadyUsed } from './activationLinkAlreadyUsed';
import { activationSuccess }         from './activationSuccess';
import { bookmarks }                 from './bookmarks';
import { profile }                   from './profile';

export const user = {
  activationError,
  activationLinkAlreadyUsed,
  activationSuccess,
  bookmarks,
  profile,
};